import { render, staticRenderFns } from "./PyramidViz.vue?vue&type=template&id=2f53c86a&scoped=true&"
import script from "./PyramidViz.vue?vue&type=script&lang=js&"
export * from "./PyramidViz.vue?vue&type=script&lang=js&"
import style0 from "./PyramidViz.vue?vue&type=style&index=0&id=2f53c86a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53c86a",
  null
  
)

export default component.exports